import React from "react";
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";
import notFoundAnimation from "../Assets/notFound.json";

const NotFound = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    const token = localStorage.getItem("tokenInv");
    if (token) {
      navigate("/document");
    } else {
      navigate("/");
    }
  };
  return (
    <div
      style={{
        height: "100vh",          
        display: "flex",
        flexDirection: "column",  
        justifyContent: "center", 
        alignItems: "center",     
        textAlign: "center",
        padding: "20px",
        boxSizing: "border-box",  
      }}
    >
      <Lottie animationData={notFoundAnimation} style={{ height: 300 }} />
      <h2>Oops! Page Not Found</h2>
      <p>The page you’re looking for doesn’t exist.</p>
      <button
        onClick={handleRedirect}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#1976d2",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Go Back
      </button>
    </div>
  );
};


export default NotFound;
